export const PHOTOGRAPHY = {
  name: 'Photography',
  description: [''],
  photos: [
    { uri: '/photography/Arashiyama.JPG', title: 'Arashiyama, Kyoto, Japan' },
    { uri: '/photography/Bath.JPG', title: 'Bath, England' },
    { uri: '/photography/Belem.JPG', title: 'Belem, Portugal' },
    { uri: '/photography/Highland.jpeg', title: 'Cladish, Scotland' },
    { uri: '/photography/England.jpeg', title: 'Dorset, England' },
    { uri: '/photography/Edinburgh.JPG', title: 'Edinburgh, Scotland' },
    { uri: '/photography/Gold Bluffs.jpeg', title: 'Gold Bluffs, Redwood National Forest, California' },
    { uri: '/photography/Golden Gardens.jpeg', title: 'Golden Gardens Park, Seattle, Washington' },
    { uri: '/photography/Porto.jpeg', title: 'Igreja do Carmo, Porto, Portugal' },
    { uri: '/photography/Skye.JPG', title: 'Isle of Skye, Scotland' },
    { uri: '/photography/Kastellet.JPG', title: 'Kastellet, Copenhagen, Denmark' },
    { uri: '/photography/Oxford.JPG', title: 'Magdalen College, Oxford, England' },
    { uri: '/photography/Okinawa.JPG', title: 'Okinawa, Japan' },
    { uri: '/photography/Quirang.JPG', title: 'Quirang, Isle of Skye, Scotland' },
    { uri: '/photography/Kyoto.JPG', title: 'Sanjusangendo, Kyoto, Japan' },
    { uri: '/photography/Gum.jpeg', title: 'Seattle, Washington' },
    { uri: '/photography/St Joseph.jpeg', title: 'St Joseph, Michigan' },
    { uri: '/photography/Stonehenge.JPG', title: 'Stonehenge, England' },
    { uri: '/photography/Scotland.jpeg', title: 'Three Sisters, Glencoe, Scotland' },
    { uri: '/photography/Trolltunga.JPG', title: 'Trolltunga, Norway' },
    { uri: '/photography/Michigan.JPG', title: 'West Bloomfield, Michigan' },
  ],
  component: 'grid',
  styles: {
    groupHeight: 350,
  },
}